import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { drawerTransition, modalTransitionDuration, backdropTransition, transitionDuration } from '../../../../../Util/PageTransitions'
import './AddWebsiteContent.css'
import CornerCloseButton from '../../../../../Util/CornerCloseButton/CornerCloseButton'
import Switch from 'react-switch'
import { config } from '../../../../../config'
import WarningDialogue from "../../../../../Util/WarningDialogue"
import axiosApi from '../../../../../core/interceptor/interceptor'
import { messages } from '../../../../../messages'
import defaultImg from '../../../../../assets/default-add-img.png'
import { EVENT_TYPE } from '../../../../../Util/helper'
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { toast } from "react-toast";

export default function AddWebsiteContent(props) {

  const [cropper, setCropper] = useState();
  const [cropData, setCropData] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');
  const [cropSection, setCropSection] = useState(false);
  const [img, setImg] = useState(props.itemDetails.image ? <img src={`${config.cdnUrl}/events/${props.itemDetails.image}`} alt={props.itemDetails.image} /> : <img src={defaultImg} alt='default-add-img' />);
  const [data, setData] = useState({
    is_visible: props.itemDetails.is_visible,
    description: props.itemDetails.description,
    image: props.itemDetails.image,
    name: props.itemDetails.name,
    section_id: props.sectionId,
  });
  const [imgUrl, setImgUrl] = useState(props.itemDetails.image ? `${config.cdnUrl}/events/${props.itemDetails.image}` : defaultImg);
  const [errors, setErrors] = useState({
    name: '',
    description: '',
    image: ''
  })
  const [validImg, setValidImg] = useState(props.itemDetails.image ? true : false);
  useEffect(() => {
    handleValidation();
    //eslint-disable-next-line
  }, [data]);

  const cancelChangesHandler = () => {
    props.onClose();
    props.isAddOrEdit(false, '');
  }

  const onCrop = (e, type) => {
    e.preventDefault();
    if (typeof cropper !== "undefined") {
      setCropData(type === 'cancel' ? '' : cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8));
      setImg(<img src={type === 'cancel' ? defaultImg : cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.8)} alt='' />);
      if (type === 'cancel') {
        document.getElementById('add-img').value = '';
        setData((previousFormData) => ({
          ...previousFormData,
          'image': '',
        }));
      }
      setCropSection(false);
    }
  };
  
  const handleFormChange = (e) => {
    if (e.target.type === 'file') {
      setCropSection(false);
      var file = e.target.files[0];
      if (file) {
        handleImageValidation(file, e);
        setSelectedFile(file);
        setCropSection(true);
      }
    } else {
      setData((previousFormData) => ({
        ...previousFormData,
        [e.target.name]: e.target.value,
      }));
    }
  }

  const handleSwitchChange = (e, name) => {
    setData((previousFormData) => ({
      ...previousFormData,
      [name]: e,
    }))
  }

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (handleValidation() && validImg) {
      let sectionType = '';
      if (props.sectionId === 1) {
        sectionType = EVENT_TYPE.HOME_SLIDER;
      } else if (props.sectionId === 2) {
        sectionType = EVENT_TYPE.VENUE
      } else if (props.sectionId === 3) {
        sectionType = EVENT_TYPE.INCLUSION
      } else if (props.sectionId === 4) {
        sectionType = EVENT_TYPE.BACKGROUND;
      }
      data.cropData = cropData;
      data.type = sectionType;
      if (props.isNewItem) {
        axiosApi.post(`${config.apiUrl}/web-content/create`, data).then((res) => { props.onClose(); props.isAddOrEdit(true, sectionType) })
      } else {
        axiosApi.put(`${config.apiUrl}/web-content/${props.itemDetails.id}`, data).then((res) => { props.onClose(); props.isAddOrEdit(true, sectionType) })
      }
    }
  }

  const handleImageValidation = (file, event) => {
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function (e) {
        var image = new Image();
        image.src = e.target.result;
        image.onload = function () {
          //Determine the Height and Width.
          var height = this.height;
          var width = this.width;
          if ((height < 1080 || width < 1920) && props.sectionId === 1) {
            setValidImg(false);
            setImg(<img src={defaultImg} alt='default-add-img' />);
            toast.error('Image resolution is low. It should be greater than 1920*1080.')
            setCropSection(false);
          } else {
            setImg(<img src={`${URL.createObjectURL(event.target.files[0])}`} alt='' />);
            setData((previousFormData) => ({
              ...previousFormData,
              'image': '',
            }));
            const reader = new FileReader();
            reader.onload = () => {
              setImgUrl(reader.result);
            };
            reader.readAsDataURL(event.target.files[0]);
            // setImgUrl(`${URL.createObjectURL(e.target.files[0])}`);
            setData((previousFormData) => ({
              ...previousFormData,
              'image': event.target.files[0].name,
            }));
            setValidImg(true);
          }
        };
      }
    }
  }

  const handleValidation = () => {
    let errArray = {};
    let formIsValid = true;

    if (!data['name']?.trim() && (props.sectionId === 2 || props.sectionId === 3)) {
      formIsValid = false;
      errArray['name'] = messages && messages.emptyField;
    }
    if (!data['description']?.trim() && props.sectionId === 2) {
      formIsValid = false;
      errArray['description'] = messages && messages.emptyField;
    }
    if (!data['image']) {
      formIsValid = false;
      errArray["image"] = messages && messages.uploadFile;
    }
    // if (data['image'] && cropper?.Cropper?.canvasData?.naturalWidth < 1920 ) {
    //   formIsValid = false;
    //   errArray["image"] = messages && messages.validImage;
    // }
    // if(!selectedFile){
    //     formIsValid = false;
    //     errArray["image"] = messages && messages.uploadFile;
    // }
    if (selectedFile && !selectedFile.name.match(/\.(jpg|jpeg|png|gif|svg)$/)) {
      errArray["image"] = messages && messages.notAllowedImg;
      formIsValid = false;
    }
    // if (selectedFile && selectedFile.name.match(/\.(jpg|jpeg|png|gif|svg)$/) && selectedFile.size < 1 * 1024 * 1024) {
    //   errArray["image"] = messages && messages.selectedFileSmall;
    //   formIsValid = false;
    // }
    setErrors(errArray);
    return formIsValid;
  }

  return <>
    <motion.div className='adminItemDrawerPageContainer'>
      <form encType="multipart/form-data">
        <motion.div className='adminBackdrop' onMouseDown={cancelChangesHandler} initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }} />
        <motion.div className='adminItemDrawer' initial={drawerTransition.initial} animate={drawerTransition.in} exit={drawerTransition.out} transition={{ duration: modalTransitionDuration }}>
          <div className='cropper-section cropper-section-outer'>
            {cropSection && <><Cropper
              style={{ height: 400, width: "100%", overflow: "hidden" }}
              zoomTo={0.1}
              initialAspectRatio={1}
              preview=".img-preview"
              src={imgUrl}
              viewMode={5}
              minCropBoxHeight={9}
              minCropBoxWidth={16}
              background={false}
              responsive={true}
              autoCropArea={2}
              checkOrientation={false}
              onInitialized={(instance) => {
                setCropper(instance);
              }}
              guides={true}
            />
              <div className="btn-blocks">
                <button className='btn' onClick={(e) => onCrop(e)}>Save</button>
                <button className='btn cancel-btn' onClick={(e) => onCrop(e, 'cancel')}>Cancel</button>
              </div></>}
            <div className='img-preview'>

            </div>
          </div>
          <div className={`flex-container ${cropSection ? 'data-feilds' : ''}`}>
            <div className="top-blk">
              <CornerCloseButton onClick={cancelChangesHandler} />
              <div className="adminItemDrawerPictureContainer-outer">
                <div className='adminItemDrawerPictureContainer sidebar-add-img'>
                  <label htmlFor="img" className='adminItemDrawerPicture'>
                    {img}
                  </label>
                  <div className="buttonblock">
                    <label htmlFor="add-img" className='buttonStyle changeimagebutton btn' style={{ left: '10px' }}>{(props.itemDetails.image === '' || props.itemDetails.image == null) && !data.image ? 'Add Image' : 'Change Image'}
                      <input type='file' name='image' className='siteInfoImageUploader' onChange={(e) => handleFormChange(e)} id="add-img" accept="image/*" ></input>
                    </label>
                    <span className="error">{(formSubmitted && errors["image"])}</span>
                  </div>
                </div>
                <div className={`adminItemDrawerDetailsContainer adminAddItemsFormBlockLatest ${props.sectionId === 1 ? 'FormBlockLatest-switch' : ''} `}>
                  <div className='adminAddItemsFormBlock '>
                    <div className="adminAddItemsFormBlockRow">
                      {(props.sectionId === 2 || props.sectionId === 3) && <div className="adminAddItemsFormBlockCol half">
                        <div className="input-outer-block">
                          <label>{'Name'}</label>
                          <input type='text' name="name"
                            value={data['name']}
                            onChange={(e) => handleFormChange(e)} />
                          <span className="error">{formSubmitted && errors['name']}</span>
                        </div>
                      </div>}
                      <div className="adminAddItemsFormBlockCol switch half">
                        <div className="input-outer-block">
                          <label>{'Is Visible'}</label>
                          <div className="switch">
                            <Switch
                              checked={data['is_visible']}
                              onChange={(e) => handleSwitchChange(e, 'is_visible')}
                              onColor="#8ab3b9"
                              onHandleColor="#00788B"
                              handleDiameter={20}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={13}
                              width={40}
                              className="react-switch"
                              id="material-switch"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="adminAddItemsFormBlockRow venue-desc">
                      {props.sectionId === 2 && <div className="adminAddItemsFormBlockCol half">
                        <div className="input-outer-block textarea">
                          <label>{'Description'}</label>
                          <textarea name="description"
                            value={data['description']}
                            onChange={(e) => handleFormChange(e)}
                          >
                          </textarea>
                          <span className="error">{formSubmitted && errors['description']}</span>
                        </div>
                      </div>}
                      <div className="adminAddItemsFormBlockCol half">
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div className='adminItemDrawerFooterContainer adminItemDrawerFooterContainerbtns'>
                  <div className="buttonblock">
                    <button className='btn' onClick={() => handleSubmit()} type='button'>Save</button>
                    <button className='btn white-btn' onMouseDown={cancelChangesHandler}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </form>
    </motion.div>

    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}